import "./utils/installSyncfusionGuard";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import LogRocket from 'logrocket';
import './i18n';
import { t } from "i18next";
import jwt_decode from "jwt-decode";
import setJWTToken from "./securityUtils/setJWTToken";
import { JWT_TOKEN } from "./global/constants";
// Restore the Authorization header BEFORE the first render. setJWTToken is only ever
// called by the login/tenant actions, so after a page reload the header was gone and the
// very first requests went out unauthenticated — useJobRehydration polled
// /async-job/{id}/status and got a 400, not the 404/403 the hook treats as "job is gone",
// so it fell back to waiting on a WS frame that never comes and a card restored after a
// refresh spun forever.
//
// An expired token must NOT be re-attached: SecuredRoute bounces the user to /login, and
// a stale bearer on the login request itself is rejected by the gateway.
const persistedJwt = localStorage.getItem(JWT_TOKEN);
if (persistedJwt && isUnexpired(persistedJwt)) setJWTToken(persistedJwt);

function isUnexpired(token) {
	try {
		return Date.now() < jwt_decode(token).exp * 1000;
	} catch {
		return false;
	}
}

const container = document.getElementById("root");
const titleElement = document.head.querySelector("title");
// todo : set the innerText property to value of the translated title
titleElement.innerText = t("global.appTitle");
const root = createRoot(container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// putting freshdesk icon on a lower position for toasters
try {
  document.querySelector(
    "#freshworks-container"
  ).childNodes[0].childNodes[0].style.bottom = 0;
} catch (err) {}

//LogRocket.init('hmdiky/schint');
